module.exports = __webpack_public_path__ + "static/media/creditcardbenefits-3.079622da.svg";